import { Injectable } from '@angular/core';

// Models
import { Cliente } from '../../models/cliente.model';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  clientes: Cliente[] = [
    {
      idcliente: 1,
      nombre: 'JUAN CARLOS GARCIA',
      telefono: '956584215',
      distrito: 'LIMA - SANTA ANITA',
      direccion: 'calle Pensamientos MZ J LT-25',
      contacto: {
        idcontacto: 1
      },
      servicio: {
        idservicio: 1
      },
    },
    {
      idcliente: 2,
      nombre: 'FRANSISCO DEL RIO',
      telefono: '9452148756',
      distrito: 'ATE VITARTE',
      direccion: 'calle Pensamientos MZ J LT-25',
      referencia: 'Frente al parque buenos amigos.',
      contacto: {
        idcontacto: 2
      },
      servicio: {
        idservicio: 1,
      }
    },
    {
      idcliente: 3,
      nombre: 'FRANCISCO DEL RIO',
      telefono: '985854784',
      distrito: 'SANTA ANITA',
      direccion: 'calle Pensamientos MZ J LT-25',
      referencia: 'Una cuadra frente al la AV. colectora',
      contacto: {
        idcontacto: 3
      },
      servicio: {
        idservicio: 1,
      }
    },
    {
      idcliente: 4,
      nombre: 'FRANSISCO DEL RIO',
      telefono: '9452148756',
      distrito: 'ATE VITARTE',
      direccion: 'calle Pensamientos MZ J LT-25',
      referencia: 'Frente al parque buenos amigos.',
      contacto: {
        idcontacto: 4
      },
      servicio: {
        idservicio: 1
      }
    }

  ];


  constructor() { }

  public getCliente(idcliente: number) {


    let cliente: Cliente = this.clientes.find( function(elemento) {

      return (elemento.idcliente === idcliente);
    });

    return cliente;
  }


}
